module.exports = __webpack_public_path__ + "static/celeste-ng-66c06507baa1a5ac808e71b40aa5f5d5.jpg";